import { type Relation } from '@/scripts/utils/tree';
import type { RouteItem } from '@/scripts/router/types';
import { genRoutes } from '@/scripts/router/utils-runtime';
import { routeMapRuntime } from './routeMap-runtime';
import Paths from './paths';

export const routesRelation: Relation<RouteItem> = [
  routeMapRuntime[Paths.LOGIN],
  routeMapRuntime[Paths.AUTH_CALLBACK],
  [
    routeMapRuntime[Paths.MAIN],
    [
      routeMapRuntime[Paths.CALLS],
      routeMapRuntime[Paths.MESSAGES],
      routeMapRuntime[Paths.FEEDS],
      routeMapRuntime[Paths.SHORTS],
      routeMapRuntime[Paths.User],
      routeMapRuntime[Paths.Wallet],
      routeMapRuntime[Paths.CONTACTS],
      routeMapRuntime[Paths.SETTINGS],
    ],
  ],
];

export const routes = genRoutes([[routeMapRuntime[Paths.BASE], routesRelation]]);
